import type { AppNotification, InboxActionRequest, InboxActionResult } from '@overlayqa/shared';
import { fetchApi } from './client';
import { MUTATION_TIMEOUT_MS, SCREEN_READ_TIMEOUT_MS } from './requestTimeout';

export async function listNotifications(
  token: string,
  opts: { unread?: boolean; limit?: number } = {},
): Promise<AppNotification[]> {
  const params = new URLSearchParams();
  if (opts.unread) params.set('unread', 'true');
  if (opts.limit) params.set('limit', String(opts.limit));
  const qs = params.toString();
  return fetchApi<AppNotification[]>(`/notifications${qs ? `?${qs}` : ''}`, { token, timeoutMs: SCREEN_READ_TIMEOUT_MS });
}

export async function updateInbox(token: string, request: InboxActionRequest): Promise<InboxActionResult> {
  return fetchApi<InboxActionResult>('/notifications/actions', {
    token, method: 'POST', body: JSON.stringify(request), timeoutMs: MUTATION_TIMEOUT_MS,
  });
}
